
import React from 'react'
import { useSelector } from 'react-redux';

const H5 = ({ whiteThemeColor, darkThemeColor, children }) => {

    const fontSizeMultiplier = useSelector((state) => state.fontSizeMultiplier.fontSize);
    const darkWhiteThemeToggle = useSelector((state) => state.darkWhiteThemeToggle.theme);

    return (
        <h5 style={{ fontSize: `${14 * fontSizeMultiplier / 100}px`, color: `${darkWhiteThemeToggle === "WHITE" ? whiteThemeColor = "#5F5553" : darkThemeColor = "#fff"}` }}>{children}</h5>
    )
}

export default H5